import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryCsAppealDetail = async (params: object) => {
  return await GET({
    url: Api.queryCsAppealDetail,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier'
    }
  })
}
